import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
    }
    caseStudyServices(first: 50) {
      nodes {
        name
        uri
        slug
      }
    }
    caseStudies(first: 100) {
      nodes {
        title
        uri
        caseStudyFields {
          casestudyServices {
            nodes {
              ... on CaseStudyService {
                id
                name
                slug
              }
            }
          }
          heroImage {
            node {
              altText
              sourceUrl
            }
          }
          cardImage {
            node {
              altText
              sourceUrl
            }
          }
          title
        }
      }
    }
  }
`
